import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { RoleService } from '../../services/role.service';
import { Observable } from 'rxjs';
import { DataListModel } from '../../models/data-list-model';
import { Invoice } from '../../dto/invoice';

@Injectable({
  providedIn: 'root'
})
export class FeeService {
  readonly apiPath = 'fees/';
  constructor(
    private http: HttpClient,
    private roleService: RoleService,
  ) { }

  getMany(
    pageIndex: number,
    pageSize: number,
    sortField: string,
    sortDirection: string,
    filterString: string,
    dateFilterCols: string[],
    startFilterDate: Date,
    endFilterDate: Date,
    someAdditionalData: string,
  ): Observable<DataListModel<Invoice>> {
    const params = new HttpParams()
      .set('page',            pageIndex.toString())
      .set('pageSize',        pageSize.toString())
      .set('filterString',    filterString)
      .set('sortField',       sortField)
      .set('sortDirection',   sortDirection )
      .set('someAdditionalData', someAdditionalData );
      return this.http.get(this.apiPath, { params }) as Observable<DataListModel<Invoice>>;
  }
}
